export const TYPE_SUMMARY = 'summary';
export const TYPE_DETAILED = 'detailed';

// Report levels shown in the criteria segmented control. Department and
// Department + Cost Centre are both Summary reports (they differ only in
// granularity); Full details is the Detailed report.
export const LEVEL_DEPARTMENT = 'department';
export const LEVEL_DEPARTMENT_COST_CENTRE = 'department_cost_centre';
export const LEVEL_FULL_DETAILS = 'full_details';

export const DEFAULT_LEVEL = LEVEL_DEPARTMENT_COST_CENTRE;

// A level resolves to one of the two backend report types.
export const levelToReportType = (level) => (level === LEVEL_FULL_DETAILS ? TYPE_DETAILED : TYPE_SUMMARY);

// Synthetic department-level row that gathers every comparison-version cost
// centre with no code match in the current structure (Department + Cost Centre
// level comparison only). Must mirror the backend id.
export const NOT_IN_CURRENT_STRUCTURE_ID = 'not_in_current_structure';
